import { render } from "./VirtualrealEstateView.vue?vue&type=template&id=893006d4&scoped=true"
import script from "./VirtualrealEstateView.vue?vue&type=script&lang=js"
export * from "./VirtualrealEstateView.vue?vue&type=script&lang=js"

import "./VirtualrealEstateView.vue?vue&type=style&index=0&id=893006d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-893006d4"]])

export default __exports__